export const getProductPrice = (product, productCatalog, menuSize = -1) => {
	const discountValue = (priceToDiscount) => {
		if(product.discount) {
			switch(product.discount.discountType) {
			case "simpleDiscountFixedAmount": return product.discount.discountValue;
			case "percentDiscount": return (priceToDiscount * product.discount.discountValue) / 100;
			}
		}
		return 0;
	};

	if (product.price) {
		return {
			basePrice: product.price,
			discountPrice: product.price - discountValue(product.price)
		};
	} else {
		const calculatedPrice = product.groups.reduce((accumulator, currentValue) => {
			if (currentValue.options.showIfConfigurationOptionSelected) {
				const optionIndex = currentValue.options.showIfConfigurationOptionSelected.optionIndex;
				if (menuSize !== -1 && menuSize !== optionIndex) {
					return accumulator;
				} else {
					const config = product.configurations.find(c => c.id === currentValue.options.showIfConfigurationOptionSelected.configurationId);
					if (config && config.options && config.options.defaultSelected !== optionIndex) {
						return accumulator;
					}
				}
			}
			let groupProduct = null;
			if (currentValue.options.defaultSelected && productCatalog.products.some(p => p.id === currentValue.options.defaultSelected)) {
				groupProduct = productCatalog.getProduct(currentValue.options.defaultSelected, true);
			}
			return accumulator + (groupProduct ? groupProduct.getPriceInGroup({ applyDiscount: false }) : 0);
		}, 0);
		return {
			basePrice: calculatedPrice,
			discountPrice: calculatedPrice - discountValue(calculatedPrice)
		};
	}
};
